import * as types from './actionTypes';
import { PopupDescription, PopupType } from './util';

export interface PopupState {
  popupDescription: PopupDescription;
}

const initialState: PopupState = {
  popupDescription: {
    visible: false,
    popupType: PopupType.Loading,
  },
};

export default function reduce(
  state: PopupState = initialState,
  action: types.PopupAction
): PopupState {
  switch (action.type) {
    case types.TOGGLE_POPUP: {
      return {
        ...state,
        popupDescription: {
          visible: action.visible,
          popupType: action.popupType,
          message: action.message,
        },
      };
    }
    default:
      return state;
  }
}
